<template>
  <div>
    <!-- 该组件用于左侧具备菜单栏的部分的面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item v-for="(item,index) in breadCrumbList" :key="index">
        <span :class="{ 'click-true': index !== breadCrumbList.length-1, 'click-false': index === breadCrumbList.length-1 }" @click="gotoRouter(item,index)">{{item.name}}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
  </div>
</template>

<script>
export default {
  props: {
    breadCrumbList: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {

    }
  },
  methods: {
    gotoRouter(item, index) {
      if (index === this.breadCrumbList.length - 1) {
        return
      }
      this.$emit('handleBreadCrumb', item.path)
    }
  }
}
</script>

<style lang="less" scoped>
.click-true{cursor: pointer;}
.el-divider--horizontal {margin: 15px 0;}
@media screen and (max-width: 420px) {
  .el-divider--horizontal {width: 95%; margin: 15px auto;}
}
</style>



// WEBPACK FOOTER //
// src/pages/components/breadcrumb-new.vue